import premiumLock from 'assets/images/locked.png'
import { IconPremiumPostLockedOutline } from 'assets/svg/sprite'
import { formatVideoTime } from 'lib/dayjs'

import { type IProps } from './ImageFile.types'
import './_imageFile.scss'

export const ImageFile = ({
  file,
  postIndex,
  fileIndex,
  postData,
  dataQuery,
  previewData
}: IProps) => {
  const isLocked = Boolean((file as any)?.locked)
  const previewSrc = (file as any)?.preview?.src ?? null
  const hasPreview = Boolean(previewSrc)
  const orientationClass =
    file?.orientation === 'Portrait'
      ? 'post__files__file--portrait'
      : file?.orientation === 'Landscape'
        ? 'post__files__file--landscape'
        : ''
  const handleClick = () => {
    const fileType = 'photo'

    const {
      minimized,
      updateSelectedPost,
      handleMinimize,
      addModal
    } = previewData

    if (minimized) {
      updateSelectedPost(
        postIndex,
        fileIndex,
        fileType,
        postData,
        dataQuery
      )

      handleMinimize(false)
      return
    }

    addModal(
      postIndex,
      fileIndex,
      fileType,
      postData,
      dataQuery
    )
  }

  return (
    <div
      className={`post__files__file ${orientationClass}`}
      onClick={handleClick}
      style={
        isLocked && !hasPreview
          ? {
              background: 'linear-gradient(157.59deg, #181920 0%, #0f0f13 100%)'
            }
          : undefined
      }
    >
      {hasPreview && (
        <img
          src={previewSrc}
          alt='Post file'
        />
      )}

      {isLocked && (
        <div className='post__cta'>
          {hasPreview ? (
            <div className='post__cta__icon'>
              <IconPremiumPostLockedOutline />
            </div>
          ) : (
            <div className='post__preview-lock'>
              <img
                src={premiumLock}
                alt=''
              />
            </div>
          )}

          <p className='post__cta__text'>
            {file?.duration != null
              ? 'Premium Video'
              : 'Premium Photo'}
          </p>
        </div>
      )}

      {file?.duration != null && (
        <div className='post__files__file__duration'>
          {formatVideoTime(file.duration)}
        </div>
      )}
    </div>
  )
}